import React from 'react';

export default ({ className, ...other }) => (
  <svg
    {...other}
    className={`icon w-404 ${className || ''}`}
    viewBox="0 0 368 254"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_4" data-name="Rectangle 4" width="368" height="254" transform="translate(760 191)" fill="#fff" stroke="#707070" strokeWidth="1" />
      </clipPath>
    </defs>
    <g id="Mask_Group_1" data-name="Mask Group 1" transform="translate(-760 -191)" clipPath="url(#clip-path)">
      <g id="Group_5" data-name="Group 5" transform="translate(-16 -73)">
        <text id="_404" data-name="404" transform="translate(960 463)" fill="#fff" fontSize="251" fontFamily="Suranna"><tspan x="-183.584" y="0">404</tspan></text>
        <path id="Path_6" data-name="Path 6" d="M5266,262.6V481.971" transform="translate(-4306 14.364)" fill="none" stroke="#54c6e0" strokeLinecap="round" strokeWidth="11" />
      </g>
    </g>
  </svg>
);
